module.exports = __webpack_public_path__ + "stylesheets/both-landings-common_f71c4a2c9ddc4ff1c2cd4987e15974d2.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/both-landings-common.less
// module id = vzSK
// module chunks = 55